module.exports = __webpack_public_path__ + "static/ambasador_baranska-119e3dd1b82c861f467a562f49b18ee1.png";